import { BREAKPOINTS } from '@skyscanner-internal/backpack-web/bpk-component-breakpoint';

import type { Device } from '@web-platform/shared-travel-tools-types/src/context';

export const getMatchSSR = (query: string, device: Device): boolean => {
  switch (query) {
    case BREAKPOINTS.MOBILE:
      return !!device.isMobilePhone;
    case BREAKPOINTS.TABLET:
      return !!device.isTablet;
    case BREAKPOINTS.ABOVE_MOBILE:
      return !device.isMobilePhone;
    case BREAKPOINTS.ABOVE_TABLET:
      return !!device.isBrowser;
    default:
      return false;
  }
};
